module.exports = __webpack_public_path__ + "img/Logo_Wieleroutfits_2021_RGB.cc094346.jpg";